module.exports = __webpack_public_path__ + "img/chicken-win.59448528.png";